//
//
//
//

export default {
  name: "ProductDistributionCell.vue",
  props: ["value"],
  computed: {
    firstPart: function() {
      return this.value.split(" > ").slice(0, this.value.split(" > ").length - 1).join(" > ")
    },
    lastPart: function() {
      return this.value.split(" > ")[this.value.split(" > ").length - 1]
    }
  }
}
